module.exports = __webpack_public_path__ + "media/icons/4@2x-f51fae0d.png";